import React, { ComponentProps } from 'react';
import { Route, withRouter, RouteComponentProps } from 'react-router-dom';

import { fomatParentPath, isMobile } from '../../utils';
import { MobWorkBanch } from '../../lib';
import { layoutPublicUrl } from '../../constants';

function WorkBench(props: RouteComponentProps & ComponentProps<any>) {
  let parentPath: string = fomatParentPath(props);
  if (window.location.pathname.replace(layoutPublicUrl, '').indexOf("/mobile") === 0) {

    parentPath = `${layoutPublicUrl}/mobile/index`
  }
  return (
    <Route weId={`${props.weId || ''}_pb8iga`} exact path={`${parentPath}/`}>
      {
        <MobWorkBanch weId={`${props.weId || ''}_t8wf3t`} />
      }
    </Route>
  )
}

export default withRouter(WorkBench);